import Route from 'cio/routes/base';

export default class SetPasswordRoute extends Route {
  redirect() {
    this.router.transitionTo('settings.personal', { queryParams: { isEditingPassword: true } });
  }
}
